/* eslint-disable */
import _ from 'underscore';
import backbone from 'backbone';
import TaskProgressView from '@bingads-webui-static-legacy/uet/view/uploadConversions/taskProgress';
import UploadService from '@bingads-webui-component-legacy/azure-upload/index';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import * as safeJson from '@bingads-webui/safe-json';
import dateUtils from '@bingads-webui-component-legacy/humanize/date';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import config from '@bingads-webui-component-legacy/config/index';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!uet');
function processBlobUrl(url) {
  var urlWithoutSas = url && url.slice(0, url.indexOf('?'));
  this.fileUrl = urlWithoutSas;
  this.fileIdentifier = getFileIdentifier(urlWithoutSas);
  var message = 'Uploaded successfully. File name: ' + this.options.file.name + ', size: ' + this.options.file.size + 'bytes, blobUrl: ' + urlWithoutSas;
  instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'UploadConversions/uploadFileTask', message);
}
function getFileIdentifier(url) {
  return url.substr(url.lastIndexOf('/') + 1);
}
function createPreviewTask(fileIdentifier) {
  var utcNow = dateUtils.utcNow();
  this.postData = {
    data: {
      '@odata.type': '#Model.OfflineConversionUploadTaskItem',
      'FileIdentifier': fileIdentifier,
      'Name': this.options.file.name + dateUtils.toString(utcNow, '_yyyy_MM_dd_HH_mm_ss', 'en-US'),
      'Type': 'OfflineConversionUploadPreview',
      'Cron': '',
      'NotificationType': 'Always',
      'NotificationMedium': 'Email',
      'TimeZoneId': 50
    }
  };
  this.postTaskUrl = '/Customers()/Accounts()/TaskItems?$expand=TaskItemExecutions';
}
function processErrorResponse(err) {
  if (_.isEmpty(err)) {
    err = {};
  }
  if (_.isString(err)) {
    try {
      var parsedErr = JSON.parse(err);
      err = parsedErr;
    } catch (e) {}
  }
  var errorMsgKey = 'UnifiedEventTracking_UploadConversions_GenericError';
  this.errorLog = _.extend({}, this.errorLog, _.pick(err, 'readyState', 'responseText', 'status', 'statusText'), _.pick(err.headers, 'x-ms-requestid', 'x-ms-trackingid'));
  if (_.isEmpty(this.errorLog)) {
    if (_.isString(err.error) && (err.error.includes('NotReadableError') || err.error.includes('NotFoundError'))) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'UploadConversions/uploadFileTask', 'Non XHR error:' + JSON.stringify(err));
      errorMsgKey = 'FileUpload_FileNotReadableError';
    } else {
      instrumentation.logMessage([constants.LOGCATEGORY.ERROR], constants.LOGLEVEL.INFO, 'UploadConversions/uploadFileTask', 'Non XHR error:' + JSON.stringify(err));
    }
  } else {
    instrumentation.logMessage([constants.LOGCATEGORY.ERROR], constants.LOGLEVEL.INFO, 'UploadConversions/uploadFileTask', JSON.stringify(this.errorLog));
  }
  this.trigger('error', {
    errorMsgKey: errorMsgKey,
    log: this.errorLog
  });
}
function parseTaskId(data) {
  var executionObj = _.first(data.TaskItemExecutions);
  this.taskId = data.Id;
  this.executionId = executionObj && executionObj.Id;
  instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, '/UploadConversions/uploadFileTask/run', 'TaskId: ' + this.taskId + ', ExecutionId: ' + this.executionId);
}
var Task = function (options) {
  this.options = options || ({});
  this.view = new TaskProgressView({
    model: {
      type: 'Upload',
      statusText: this.options.statusText,
      completeText: this.options.completeText
    },
    task: this
  });
};
Task.prototype.run = function (cb) {
  var uploadService = new UploadService({
    file: this.options.file,
    bulkFileType: 'OfflineConversionInputFile',
    onProgress: (function (e) {
      if (!config.get('IsNewUI')) {
        this.trigger('update', e.loaded, e.total);
      }
    }).bind(this)
  });
  uploadService.start().bind(this).then(function (data) {
    processBlobUrl.call(this, data);
  }).then(function () {
    createPreviewTask.call(this, this.fileIdentifier);
    return odata.post(this.postTaskUrl, this.postData).bind(this);
  }).then(function (data) {
    parseTaskId.call(this, data);
    this.trigger('done', {
      TaskId: this.taskId,
      ExecutionId: this.executionId,
      FileName: this.options.file.name
    });
  }).catch(function (err) {
    processErrorResponse.call(this, err);
  }).nodeify(cb);
};
_.extend(Task.prototype, backbone.Events);
export default Task;

